import React, { Component } from "react";
import Moment from 'react-moment';
import moment from "moment"

import {Badge} from "react-bootstrap";



var flattenObject = function(ob) {
	var toReturn = {};

	for (var i in ob) {
		if (!ob.hasOwnProperty(i)) continue;

		if ((typeof ob[i]) == 'object') {
			var flatObject = flattenObject(ob[i]);
			for (var x in flatObject) {
				if (!flatObject.hasOwnProperty(x)) continue;

				toReturn[i + '.' + x] = flatObject[x];
			}
		} else {
			toReturn[i] = ob[i];
		}
	}
	return toReturn;
};


function extractAnyVars(data){
  let r=[]
  let flatr=flattenObject(data)

  for (let key in flatr){
if(key.includes(".var"))
    r.push(flatr[key])

  }
  return r
}

function divBar(value,data){
  let level=parseInt(value/6553)

  if(data.name_active==data.name_inactive){


  if(value==0)
    level=-1
  else if (value<150)
    level=0
  else if (value<300)
    level=1
  else if (value<750)
    level=2
  else if (value<1500)
    level=3
  else if (value<3000)
    level=4
  else if (value<6000)
    level=5
  else if (value<12000)
    level=6
  else if (value<20000)
    level=7
  else if (value<30000)
    level=8
  else if (value>30000)
    level=9



  

  return (<div className="blockflex">
              <div className={level>=9? ("blockbar highlight"):("blockbar")}  ></div>
              <div className={level>=8? ("blockbar highlight"):("blockbar")}  ></div>
              <div className={level>=7? ("blockbar highlight"):("blockbar")}  ></div>
              <div className={level>=6? ("blockbar highlight"):("blockbar")}  ></div>
              <div className={level>=5? ("blockbar highlight"):("blockbar")}  ></div>
              <div className={level>=4? ("blockbar highlight"):("blockbar")}  ></div>
              <div className={level>=3? ("blockbar highlight"):("blockbar")}  ></div>
              <div className={level>=2? ("blockbar highlight"):("blockbar")}  ></div>
              <div className={level>=1? ("blockbar highlight"):("blockbar")}  ></div>
              <div className={level>=0? ("blockbar highlight"):("blockbar")}  ></div>
          </div>)
  }else{
    return(<span></span>)
  }


}


function shake(v){
  if(v===1)
    return "shakeBack1"
  else
    return "shakeBack2"
}

function icon_from_name(name_string){
	var name=name_string.toLowerCase()
  var default_input_icon='fa-exclamation'
	//Default icon
	var r=default_input_icon
	//first item is the icon you want followed by a list of words to associate to that icon
	var iconlist=[
      ['fa-close','disable','No input'],
			['fa-bed','bed','bedroom','epilepsy','enuresis','bed wet','enuresis sensor'],
			['fa-volume-up','audio','mic','microphone','sound','sound detector','noise detector','shout detector'],
			['fa-paw','motion','motion detector','PIR','movement','movement sensor','motion sensor'],
			['fa-tint','flood'],
			['fa-sign-out','door'],
			['fa-windows','window','windows'],
			['fa-square','floor'],
			['fa-bell','buzzer','beep','bell','beep test', 'buzz'],
			['fa-lightbulb-o','lamp on','light on','lights on','lamp on','light off','lamp off','lights off'],
			['fa-phone','make call','call'],
			['fa-mobile','sms','text','send text','send sms'],
			['fa-envelope-o','email','mail','send email','send mail'],
			['fa-archive','log'],
			['fa-times','no action'],
      ['fa-thermometer-half','Temperature Sensor','fridge','freezer'],
      ['fa-bolt','Light','lux']

		]
    let name_string_split=name.split(" ")
	//convert everything to lowercase
	iconlist=JSON.parse(JSON.stringify(iconlist).toLowerCase())

	iconlist.forEach(function(e){
    if(e.indexOf(name)!==-1){
			r=e[0];
		}
	});

  //Basic match failed



  if (r==default_input_icon){
    if (name.includes("fridge") || name.includes("freezer") || name.includes("temperature") ){
      r='fa-thermometer-half'
    }
    iconlist.forEach(function(e){

      for(let j=0;j<name_string_split.length;j++){
        if(e.indexOf(name_string_split[j])!==-1){
          r=e[0];
        }
      }


    });



  }
	return r;
}

export const InputDisplay = (props)=>{
  var l=props.data
  let icon_name=icon_from_name(l.name)
  let value_suffix=""
  let alert=""
  let avg12h=""
  let logic_count=0
  let keepalive="---"
  let displayState=""
  if ("keepalive" in l){
    keepalive=new Date(l.keepalive)
  }

  if ("logic" in props){
    for (var key in props.logic){
        try{
          let varname="input"+l.id+"filtered"

          let varsInlogic=extractAnyVars(props.logic[key].logic)



        if(varsInlogic.includes(varname)){
          logic_count=logic_count+1
          if(props.logic[key].state==true){
            alert=<Badge title="Active in an alert!">!</Badge>
            displayState="alert"+props.logic[key].level
            console.log("IN ALERT")
        }
      }
    }
    catch(err){}
  }
  }

  if(l.identify-new Date()>-5000){
    alert=<Badge title="">*</Badge>
  }


  if(l.tamper==1){
    alert=<Badge title="Case is open">!</Badge>
  }
  if ("avg12h" in l){
      avg12h=(<span><br/><i><span className="lineAbove">12h </span>({l.avg12h}°C)</i></span>)
      if(l.avg12h=="-"){
        avg12h=""
      }
  }
  if("type" in l){
    if(l.type==512){
        icon_name="fa-thermometer-half"
    }
    if(l.type==515){ //Motion sensor
        icon_name="fa-paw"
    }
    if(l.type==513 ){ //Door sensor
        icon_name="fa-sign-out"
    }
    if(l.type==518 ){ //Flood Sensor overide
        icon_name="fa-tint"
    }

  }
  if(icon_name=="fa-thermometer-half" ){
      value_suffix="°C"
  }
  if(icon_name=="fa-bolt" ){
      value_suffix=" Lux" }
  let momenttime=(<Moment fromNow>{new Date(l.last*1000-2000)}</Moment>)
  if(l.last==0 || l.last==""|| l.last==undefined ){
    momenttime="---"
    let alert=(<Badge title="Waiting for a reading...">!</Badge>)
  }
  if(props.data.disabled===true){
    return ("")
  }
  else{
    return (<div key={l.id} onClick={()=>props.callback(props.data)} className="col textCenter" extra={new Date(l.last*1000)+"\nIn Logic:"+logic_count+ "\nKeepalive:"+keepalive}><div><div className={'inputCircle inputcol'+displayState+' '+shake(l.state)}><i className={"fa "+icon_name+" fa-2x"}></i>{ divBar(l.state,l)}</div>{alert}</div><span className={"tamper"+l.tamper}>{l.name}:<b>{l.state_text}{value_suffix} </b>{avg12h}<p>{momenttime}</p></span></div> )
  }
}



// WEBPACK FOOTER //
// ./src/programmerComponents/InputDisplay.js